<template>
<div>
    <div v-for="(stat,i) in stats" :key="i">
        <h6 class="m-0 py-4 ds-text-xs font-semibold text-gray-500 uppercase whitespace-no-wrap">{{stat.label}}</h6>
        <p class="ds-text-base text-gray-900 font-normal" v-if="!testValueForHtml(stat.value)">{{ formatValue(stat.value) }}</p>
        <div v-else class="ds-text-base text-gray-900 font-normal fullWidth break-words" v-html="stat.value" />
    </div>
  </div>
</template>

<script>
export default {
    props: {
        stats: {
            type: Array
        }
    },
    methods: {
        testValueForHtml(value){
            return /<|\/|>/.test(value);
        },
        formatValue(value) {
            if (!/<|\/|>/.test(value)) {
                return value.replace(/\|/g, ', ')
            } else {
                return value;
            }
        }
    }
}
</script>

<style lang="scss">
.fullWidth {
    ul {
        padding-left: 18px !important;
    }

    ol {
        padding-left: 18px !important;
    }
}
</style>